import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

// Lazy load components for better performance
const Dashboard = lazy(() => import("./index"));
const Planning = lazy(() => import("./planning"));
const Taken = lazy(() => import("./taken"));
const TakenEdit = lazy(() => import("./taken-edit"));
const TakenInsert = lazy(() => import("./taken-insert"));
const Compliance = lazy(() => import("./compliance"));
const ComplianceEdit = lazy(() => import("./compliance-edit"));
const ComplianceInsert = lazy(() => import("./compliance-insert"));
const Voorraad = lazy(() => import("./voorraad"));
const VoorraadEdit = lazy(() => import("./voorraad-edit"));
const VoorraadInsert = lazy(() => import("./voorraad-insert"));
const Rapportages = lazy(() => import("./rapportages"));

// Loading component
const Loading = () => (
  <div className="d-flex justify-content-center mt-5">
    <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

const PreventiefOnderhoudRouter = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Dashboard */}
        <Route path="/" element={<Dashboard />} />
        
        {/* Planning routes */}
        <Route path="/planning" element={<Planning />} />
        
        {/* Onderhoudstaken routes */}
        <Route path="/taken" element={<Taken />} />
        <Route path="/taken/toevoegen" element={<TakenInsert />} />
        <Route path="/taken/:id/bewerken" element={<TakenEdit />} />
        
        {/* Compliance routes */}
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/compliance/toevoegen" element={<ComplianceInsert />} />
        <Route path="/compliance/:id/bewerken" element={<ComplianceEdit />} />
        
        {/* Voorraad routes */}
        <Route path="/voorraad" element={<Voorraad />} />
        <Route path="/voorraad/toevoegen" element={<VoorraadInsert />} />
        <Route path="/voorraad/:id/bewerken" element={<VoorraadEdit />} />
        
        {/* Rapportages */}
        <Route path="/rapportages" element={<Rapportages />} />
      </Routes>
    </Suspense>
  );
};

export default PreventiefOnderhoudRouter;